import { ToastProvider } from 'react-toast-notifications';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import language from '../../config/es';
import LabelChargeData from '../../components/Label/labelChargeData';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';

import { es_vacio } from '../../config/validate';
import { getTemplates } from '../../redux/template.duck';
import { findBySocieties } from '../../redux/collectingEntity.duck';
import { findSocieties } from '../../redux/society.duck';
import {
  getAssignation,
  create,
  update,
} from '../../redux/templateAssign.duck';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  requireSelection,
  requireValues,
} from '../../components/Crud/crudHelpers';
import {
  useCrudState,
  useCrudLifecycle,
} from '../../components/Crud/crudHooks';
import {
  RequiredFieldsAlert,
  SelectField,
  TextField,
} from '../../components/Crud/CrudFields';
import { CrudButtons, CrudPage } from '../../components/Crud/CrudLayout';

const TemplateAssig = () => {
  const ref = useRef()
  const dispatch = useAppDispatch();
  const [enable, setEnable] = useState(false);

  const [showloadingTemplate, setShowloadingTemplate] = useState(false);
  const [showloadingEntity, setShowloadingEntity] = useState(true);
  const [showloadingAssignation, setShowloadingAssignation] = useState(true);

  const {
    data,
    refreshState: refreshData,
    updateState,
    viewNotification,
  } = useCrudState({
    id: null,
    collectionEntity: { value: 0, label: '', error: '', auth: '' },
    society: { value: '', label: '', error: '', auth: '' },
    header: {
      value: 0,
      label: language.messages.templateAssign.none,
      error: '',
    },
    detail: {
      value: 0,
      label: language.messages.templateAssign.none,
      error: '',
    },
    footer: {
      value: 0,
      label: language.messages.templateAssign.none,
      error: '',
    },
    auth: JSON.parse(sessionStorage.getItem('user')),
    name: { value: '', error: '' },
    separator: { value: '', error: '' },
    showloadingSociety: false,
    templates: [],
    columns: [],
    entities: [],
    societies: [],
    errors: [],
    currentAssignation: null,
    response:''
  });
  data.response = useSelector((store) => store.templateAssignationReducer.createAssign);
  data.currentAssignation = useSelector(
    (store) => store.templateAssignationReducer.assignation
  );
  data.templates = useSelector((store) => store.templateReducer.templates);
  data.societies = useSelector((store) => store.societyReducer.societies);
  data.entities = useSelector(
    (store) => store.collectingEntityReducer.cEntities
  );
  useEffect(() => {
    void responseAction();
    setEnable(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.response]);
  useCrudLifecycle(ref, data, () => {
    void loadTemplates();
    void loadSocieties();
  });
  useEffect(() => {
    if (!es_vacio(data.society.value)) {
      data.collectionEntity = { value: 0, label: '', error: '', auth: '' };
      void loadEntities();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.society]);

  useEffect(() => {
    if (data.templates.length > 0) {
      let empty = { value: 0, label: language.messages.templateAssign.none };
      data.templates.unshift(empty);
      setEnable(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.templates]);

  useEffect(() => {
    clearDataAssign();
    if (!es_vacio(data.collectionEntity.label)) {
      void loadDataAssig();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.collectionEntity]);

  useEffect(() => {
    setEnable(true);
    if (es_vacio(data.currentAssignation) || data.currentAssignation === null) {
      clearDataAssign();
    } else {
      setDataAssignation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.currentAssignation]);
  //#region functions
  const responseAction = async () => {
    if (!es_vacio(data.response) && data.response !== null) {
      viewNotification(
        language.messages.msmRegister.replace('{0}', data.response.name),
        'success'
      );
    }
  };
   
  const loadEntities = async () => {
    setShowloadingEntity(false);
    await dispatch(findBySocieties(data.society.value));
    setShowloadingEntity(true);
  };
  const loadDataAssig = async () => {
    setShowloadingAssignation(false);
    await dispatch(
      getAssignation(data.collectionEntity.value, data.auth.id.user.username)
    );

    setShowloadingAssignation(true);
  };
  const setDataAssignation = () => {
    if (data.currentAssignation !== null) {
      data.id = data.currentAssignation.id;
      data.name.value = data.currentAssignation.name;
      data.header = {
        value:
          data.currentAssignation.headerTemplate !== null
            ? data.currentAssignation.headerTemplate.id
            : 0,
        label:
          data.currentAssignation.headerTemplate !== null
            ? data.currentAssignation.headerTemplate.name
            : language.messages.templateAssign.none,
        error: '',
      };
      data.detail = {
        value:
          data.currentAssignation.detailTemplate !== null
            ? data.currentAssignation.detailTemplate.id
            : 0,
        label:
          data.currentAssignation.detailTemplate !== null
            ? data.currentAssignation.detailTemplate.name
            : language.messages.templateAssign.none,
        error: '',
      };
      data.footer = {
        value:
          data.currentAssignation.footTemplate !== null
            ? data.currentAssignation.footTemplate.id
            : 0,
        label:
          data.currentAssignation.footTemplate !== null
            ? data.currentAssignation.footTemplate.name
            : language.messages.templateAssign.none,
        error: '',
      };
      data.separator.value =
        data.currentAssignation.separator === null
          ? ''
          : data.currentAssignation.separator;

      viewNotification(
        language.messages.templateAssign.msmLoad + data.name.value,
        'success'
      );
    }
  };
  const clearDataAssign = () => {
    data.id = null;
    data.name = { value: '', error: '' };
    data.separator = { value: '', error: '' };
    data.header = {
      value: 0,
      label: language.messages.templateAssign.none,
      error: '',
    };
    data.detail = {
      value: 0,
      label: language.messages.templateAssign.none,
      error: '',
    };
    data.footer = {
      value: 0,
      label: language.messages.templateAssign.none,
      error: '',
    };
    refreshData();
  };
  const loadSocieties = async () => {
    await dispatch(findSocieties(data.auth.id.user.userId));
    data.showloadingSociety = true;
    refreshData();
  };
  const loadTemplates = async () => {
    setShowloadingTemplate(false);
    await dispatch(getTemplates());
    setShowloadingTemplate(true);
  };

  const updateSelect = async (value, id) => {
    switch (id) {
      case 'header':
        data.header = value;
        break;
      case 'detail':
        data.detail = value;
        break;
      case 'footer':
        data.footer = value;
        break;
      case 'society':
        data.society = value;
        break;
      case 'entity':
        data.collectionEntity = value;
        setEnable(false);
        break;
      default:
        break;
    }
    refreshData();
  };
  const clearError = () => {
    data.errors = [];
    data.society.error = '';
    data.collectionEntity.error = '';
    data.separator.error = '';
    data.name.error = '';
  };
  const validate = () => {
    clearError();
    requireValues(data, ['society'], language.messages.error_no_selected);

    requireSelection(data, ['collectionEntity']);
    requireValues(data, ['name'], language.messages.error_no_selected);
    refreshData();
  };
  const saveAssign = async () => {
    validate();
    if (data.errors.length === 0) {
      setEnable(false);
      let json = {
        id: data.id,
        name: data.name.value,
        headerTemplate:
          data.header.value === 0
            ? null
            : {
                id: data.header.value,
              },
        footTemplate:
          data.footer.value === 0
            ? null
            : {
                id: data.footer.value,
              },
        detailTemplate:
          data.detail.value === 0
            ? null
            : {
                id: data.detail.value,
              },
        entity: data.collectionEntity.value,
        user_admin: data.auth.id.user.username,
        status: 1,
        separator: data.separator.value,
      };
      if (data.id === null) {
        await dispatch(create(json, data.auth.id.user.username));
      } else {
        await dispatch(update(json, data.auth.id.user.username));
      }
      setEnable(true);
    }
  };
  const onChange = async (event) => {
    switch (event.target.name) {
      case 'name':
        data.name.value = event.target.value;
        data.name.error = '';
        updateState(data.name, 'name');
        break;
      case 'separator':
        data.separator.value = event.target.value;
        data.separator.error = '';
        updateState(data.separator, 'separator');
        break;
      default:
        break;
    }
  };
  //#endregion
  return (
    <Fragment>
    <SessionConfig ref={ref}/>
      <br />
      <CrudPage
        formCol={{ md: 6, xl: 4 }}
        formIcon=" fa fa-bars"
        formTitle={language.messages.titleCEntityForm}
        form={
          <form autoComplete="off" name="detail">
            <RequiredFieldsAlert />
            <SelectField
              label={language.messages.society.title_society}
              loading={data.showloadingSociety}
              name="society"
              options={data.societies}
              className="text-uppercase small "
              field={data.society}
              onChange={updateSelect}
              changeKey="society"
            />
            <SelectField
              label={language.messages.titleCEntityForm}
              loading={showloadingEntity}
              name="entity"
              options={data.entities}
              className="text-uppercase small "
              field={data.collectionEntity}
              errorPosition="after"
              onChange={updateSelect}
              changeKey="entity"
            />

            <LabelChargeData
              label={language.messages.templateAssign.load}
              showloading={showloadingAssignation}
            />

            <TextField
              label={language.messages.templateAssign.name}
              autoComplete="nameMessage"
              disabled={!showloadingAssignation}
              name="name"
              field={data.name}
              onChange={onChange}
            />

            <CrudButtons
              wrapped
              enable={enable}
              isNew={data.id === null}
              onSave={saveAssign}
              onReload={loadDataAssig}
            />
          </form>
        }
        tableCol={{ md: 6, xl: 4 }}
        tableIcon=" fa fa-tags"
        tableTitle={language.messages.templateAssign.assign}
        table={
          <Fragment>
            <SelectField
              label={language.messages.templateAssign.head}
              required={false}
              loading={showloadingTemplate}
              isDisabled={!showloadingAssignation}
              name="header"
              options={data.templates}
              field={data.header}
              onChange={updateSelect}
              changeKey="header"
            />

            <SelectField
              label={language.messages.templateAssign.detail}
              required={false}
              loading={showloadingTemplate}
              isDisabled={!showloadingAssignation}
              name="detail"
              options={data.templates}
              field={data.detail}
              onChange={updateSelect}
              changeKey="detail"
            />

            <SelectField
              label={language.messages.templateAssign.foot}
              required={false}
              loading={showloadingTemplate}
              isDisabled={!showloadingAssignation}
              name="footer"
              options={data.templates}
              field={data.footer}
              onChange={updateSelect}
              changeKey="footer"
            />
            <TextField
              label={language.messages.templateAssign.separator}
              required={false}
              disabled={!showloadingAssignation}
              name="separator"
              field={data.separator}
              onChange={onChange}
            />
          </Fragment>
        }
      />
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <TemplateAssig />
  </ToastProvider>
);
export default App;
